import React from "react";
import ChatVisual from "../components/ChatVisual";

const ChatVisualPage = () => {
  return (
    <div style={{ height: "100vh", background: "#f7faff" }}>
      <ChatVisual />
    </div>
  );
};

export default ChatVisualPage;
